import BasicPage from "../../components/BasicPage/BasicPage";
import ArrowSubtitle from "../../components/ArrowSubtitle/ArrowSubtitle";
import styles from "./ResourceCentre.module.css";
import TabbedResourceBrowser from "../../components/TabbedResourceBrowser/TabbedResourceBrowser";
import { resources } from "../../data/resources";
import usePageTitle from "../../hooks/usePageTitle";

function ResourceCentre() {
    usePageTitle("Resource Centre");

    return (
        <BasicPage mainClassName={styles.main}>
            <div id={styles.heading}>
                <ArrowSubtitle dark={true} text={"Resources"} />
                <h1 className="main-h1">
                    Welcome to the <br />
                    Keel Mind Resource Centre
                </h1>
            </div>
            <TabbedResourceBrowser data={resources} />
        </BasicPage>
    );
}

export default ResourceCentre;
